function formatDecimal(number) {
	if (typeof number !== 'number') {
		return number
	}
	// eslint-disable-next-line no-magic-numbers
	return Number.isInteger(number) ? number : number.toFixed(2)
}

export default formatDecimal
